<template>
    <div class="chart">
        <span v-if="totalSumLabel" class="chart--total">{{ totalSumLabel }}</span>
        <bar-chart :chartData="chartData" :options="chartOptions"></bar-chart>
    </div>
</template>

<script>
    import { BarChart } from 'vue-chart-3'
    import { Chart, registerables } from 'chart.js'

    Chart.register(...registerables)

    export default {
        components: { BarChart },

        props: {
            chartData: { type: Object, default: undefined },
            totalSumLabel: { type: String, default: undefined },
        },

        data() {
            return {
                chartOptions: {
                    plugins: {
                        legend: {
                            display: false,
                        },
                    },
                },
            }
        },
    }
</script>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/mixins';
    .chart {
        &--total {
            display: flex;
            justify-content: center;
            text-align: center;
            font-weight: 500;
            font-size: $font-size--header-copy;
            margin-bottom: 25px;
        }
    }
</style>
